import React, { useCallback, useEffect, useState, useMemo } from 'react'
import styles from './index.module.less'
import { OneIconButton, OneCheckbox, OneInput, OneMessage } from '@yy/one-ui'
import { Search } from '@yy/one-icon'
import { Popover, Form } from 'antd'
import Empty from '@/components/Empty'
import { useTranslation } from 'react-i18next'
import type { FormInstance } from 'antd'
import classnames from 'classnames'
import { ChevronDown } from '@yy/one-icon'

interface ICheckboxGroupPopover {
  form?: FormInstance
  onChange?: (value: string[], oldValues?: string[]) => void
  dataSource?: any[]
  text: string
  search?: boolean
  valueKey?: string
  labelKey?: string
  name?: string
  width?: number
  maxChooseLength?: number
  // 空标签 与其他标签互斥
  noneTag?: {
    value: string
    label: string
  }
  className?: string
}
const CheckboxGroupPopover: React.FC<ICheckboxGroupPopover> = (props) => {
  const {
    onChange,
    dataSource,
    text,
    name,
    search = false,
    valueKey = 'value',
    labelKey = 'label',
    width = 180,
    maxChooseLength = dataSource?.length,
    noneTag,
    form,
    className,
  } = props
  const { t } = useTranslation()
  const [innerValue, setInnerValue] = useState([])
  const [searchList, setSearchList] = useState([])
  const triggerChange = useCallback(
    (value) => {
      let finalValues = value || []
      // 互斥逻辑
      if (noneTag?.value) {
        if (value?.includes(noneTag.value) && !innerValue?.includes(noneTag.value)) {
          finalValues = [noneTag.value]
        } else if (value?.length > innerValue?.length && innerValue?.includes(noneTag.value)) {
          finalValues = value?.filter((v) => v !== noneTag.value)
        }
      }
      setInnerValue(finalValues)
      form && form.setFieldsValue({ [name]: finalValues })
      onChange && onChange(finalValues)
    },
    [noneTag?.value, form, name, onChange, innerValue]
  )

  useEffect(() => {
    if (dataSource) {
      const finalDataSource = dataSource?.map((item) => ({
        value: item[valueKey],
        label: item[labelKey],
        number: item?.number,
        hidden: !!item?.hidden,
        disabled: !!item?.disabled,
      }))
      setSearchList(finalDataSource)
    }
  }, [dataSource, labelKey, valueKey])

  const searchHandler = useCallback(
    (e) => {
      const newSearchList = dataSource?.map((item) => {
        return {
          value: item?.[valueKey],
          label: item?.[labelKey],
          disabled: !!item?.disabled,
          number: item?.number,
          hidden: !item?.[labelKey]?.includes(e.target.value) && e.target.value,
        }
      })
      setSearchList(newSearchList)
    },
    [dataSource, labelKey, valueKey]
  )

  const clickItemHandler = useCallback(
    (disable) => {
      if (disable) {
        OneMessage.error(t('order.country.limit', { count: maxChooseLength }))
      }
    },
    [maxChooseLength, t]
  )

  const isEmpty = useMemo(() => !searchList.some((item) => !item.hidden), [searchList])
  const NoneTag = useMemo(() => {
    return (
      noneTag?.label && (
        <>
          <OneCheckbox className={classnames(styles.checkboxItem)} value={noneTag?.value}>
            {noneTag?.label}
          </OneCheckbox>
          <div className={styles.title}>{text}</div>
        </>
      )
    )
  }, [noneTag?.label, noneTag?.value, text])

  const numberFormatter = (num = 0) => {
    const _num = +num
    return _num > 99 ? '99+' : _num
  }
  return (
    <Popover
      trigger="click"
      placement="bottomLeft"
      overlayClassName={styles.formItemPopver}
      overlayInnerStyle={{
        width,
      }}
      content={
        <>
          {search && <OneInput bordered={false} placeholder={t('order.index.deliveryArea.placeholder')} prefix={<Search />} onInput={searchHandler} />}
          {!isEmpty && (
            <>
              <Form.Item className={styles.formItem} name={name}>
                <OneCheckbox.Group value={innerValue as any} onChange={triggerChange}>
                  {NoneTag}
                  {searchList.map((item) => {
                    const disabled = !innerValue?.includes(item.value) && innerValue?.length >= maxChooseLength
                    return (
                      <div className={styles.checkboxItem} key={item.value} onClick={() => clickItemHandler(disabled)}>
                        {
                          // 解决checkbox禁用点击事件不生效问题
                          disabled && <div className={styles.mask}></div>
                        }
                        <OneCheckbox disabled={disabled} className={classnames(styles.checkboxItem, { [styles.hidden]: item.hidden })} value={item.value}>
                          {item.label}
                          {item.number ? <span className={styles.orderTagNum}>{numberFormatter(item.number)}</span> : null}
                        </OneCheckbox>
                      </div>
                    )
                  })}
                </OneCheckbox.Group>
              </Form.Item>
            </>
          )}
          {isEmpty && <Empty text={t('normal.info.empty')} />}
        </>
      }
    >
      <Form.Item name={name} className={className}>
        <OneIconButton rightIcon={<ChevronDown />} className={styles.iconButton}>
          {text}
        </OneIconButton>
      </Form.Item>
    </Popover>
  )
}

CheckboxGroupPopover.displayName = 'CheckboxGroupPopover'
export default CheckboxGroupPopover
